<template>
  <div class="d-flex flex-column w-100">
    <div class="header drip-h1">
      {{ title }}
      <chip
        v-if="sideChipText"
        :class="`ml-2 ${sideChipText}`"
        :chipText="sideChipText"
      />
    </div>
    <div class="divider"></div>
    <span v-if="chipText" class="chip">{{ chipText }}</span>
  </div>
</template>
<script>
import Chip from '@/components/common/Chip'

export default {
  props: ['title', 'chipText', 'sideChipText'],
  components: { Chip }
}
</script>
<style lang="scss">
.tooltip-inner {
  width: auto !important;
  max-width: 300px !important;
}
</style>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  color: $noble-blue-500;
}
.divider {
  background: $wealthy-green-500;
  height: 3px;
  width: 200px;
}
.chip {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 22px;
  padding: 0px 16px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.6px;
  font-weight: 400;
  color: $noble-blue-500;
  background: $sky-blue-50;
  border: 1px solid $sky-blue-400;
  border-radius: 24px;
  text-decoration: none;
  cursor: pointer;
}
</style>
